import { Orders } from "./orders";
import { Link } from "react-router-dom";

export const LastTransactions: React.FC = () => {
	return (
		<div className="flex flex-col h-full w-full overflow-hidden">
			<div className="flex w-[90%] mx-auto full-hd:mb-2 qhd:mb-4 qhd-plus:mb-4 4k:mb-5 5k:mb-5">
				<h4 className="title-text self-start w-full ">Últimos lançamentos</h4>
			</div>

			<div
				id="last-transactions"
				className="last-transaction-container overflow-hidden transition-all border-radius-container flex flex-col items-center justify-center bg-[#FBFAFA] border border-[#818181] shadow-md mx-auto w-[90%]"
			>
				<Orders />
			</div>
			<div className="flex w-[90%] mx-auto">
				<Link
					to={"/extract"}
					className="underline w-full text-end text-[#8979FF] font-medium ml-auto p-text hover:brightness-75"
				>
					Ver Extrato
				</Link>
			</div>
		</div>
	);
};
